var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVolumeMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 14.6666L1.3335 1.33331",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 6.66669C11.7532 7.17782 12.0002 7.80362 12.0002 8.47969C12.0002 8.77569 11.9528 9.06202 11.8644 9.33335",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 5.33331C14.1674 6.15299 14.6668 7.19678 14.6668 8.33331C14.6668 9.27758 14.3221 10.1578 13.7272 10.8986",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 9.33335C9.3335 11.4302 9.3335 13.0209 8.71616 13.2818C8.0989 13.5428 7.37236 12.8014 5.9193 11.3188C5.16676 10.551 4.7375 10.3809 3.66683 10.3809C2.92543 10.3809 2.01849 10.4792 1.5582 9.77622C1.3335 9.43309 1.3335 8.95542 1.3335 8.00002C1.3335 7.04462 1.3335 6.56694 1.5582 6.22379C2.01849 5.52089 2.92543 5.61915 3.66683 5.61915C4.405 5.61915 4.90477 5.62581 5.30683 5.30669M9.3335 6.33335C9.3335 4.23655 9.35083 2.97913 8.7335 2.71822C8.2196 2.501 7.68839 2.97845 6.66683 4.00002",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVolumeMute);
export default __webpack_public_path__ + "static/media/icon-volume-mute.29491bb9febf029636676e6815b420ef.svg";
export { ForwardRef as ReactComponent };